<!-- Header navigation -->
<header class="navbar-bg" [class.navbar-bg--logged-out]="!isLoggedIn">
  <div class="nav-container">
    <nav class="navbar" role="navigation">
      <div
        class="burger-menu"
        id="burger-menu"
        (click)="handleHamBurger()"
        *ngIf="!isNativeApp"
      >
        <img
          *ngIf="isLoggedIn"
          src="assets/images/header/burger.svg"
          alt="Burger Menu"
          id="burger-icon"
        />
      </div>

      <div class="logo-and-balance">
        <div class="logo" (click)="handleLogo()">
          <img
            [ngStyle]="{
              display: isScrolled || isHamBurgerClicked ? 'none' : 'block'
            }"
            src="assets/images/header/logo.png"
          />
          <img
            [ngStyle]="{
              display: isScrolled || isHamBurgerClicked ? 'block' : 'none'
            }"
            src="assets/images/header/logo-small.png"
          />
        </div>

        <div
          class="balance-small"
          *ngIf="((!isDashboardPage && !isHomePage) || isScrolled || isHamBurgerClicked) && isLoggedIn"
        >
          <a [routerLink]="['/earn-redeem']" class="balance-circle" *ngIf="isLoggedIn">
            ₹{{ points.toString().split('.')[0] | number }}
            <span class="points-arrows">
              <img src="assets/images/header/points-arrows.svg" alt="Points Arrows" />
            </span>
          </a>
        </div>
      </div>

      <ul class="nav-links" *ngIf="isLoggedIn">
        <li *ngIf="showDashboard && !isHomePage">
          <a [routerLink]="['/dashboard']" routerLinkActive="active"
            >Home</a
          >
        </li>
        <li >
          <a [routerLink]="['/transactions']" routerLinkActive="active"
            >Activity</a
          >
        </li>

        <li >
          <a [routerLink]="['/tiers']" routerLinkActive="active">Rewards</a>
        </li>
        <li>
          <a [routerLink]="['/offers']" routerLinkActive="active">Offers</a>
        </li>
      </ul>

      <ng-container *ngIf="isLoggedIn && !isHomePage">
        <div
          class="profile"
          [routerLink]="['/profile']"
          routerLinkActive="profile-active"
        >
          <div class="profile-link">
            <div class="profile-circle">{{ userName | uppercase }}</div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!isLoggedIn" class="btn btn__sign-in" (click)="signIn()">
        Sign in
      </div>
      <div
        *ngIf="isLoggedIn && isHomePage"
        class="btn btn__sign-in"
        (click)="handleNavigation('dashboard')"
      >
        Dashboard
      </div>
    </nav>
  </div>
</header>

<!-- Overlay for nav drawer -->
<div
  class="nav-overlay"
  [ngStyle]="{ display: isHamBurgerClicked ? 'block' : 'none' }"
  (click)="handleHamBurger()"
></div>

<!-- Add the drawer element -->
<div class="drawer" [ngClass]="{ 'drawer-open': isHamBurgerClicked }">
  <ul>
    <li
      *ngIf="isLoggedIn"
      [routerLink]="['/dashboard']" routerLinkActive="active"
      (click)="handleNavigation('dashboard')"
    >
      <a>Home</a>
    </li>

    <li *ngIf="isLoggedIn" [routerLink]="['/transactions']" routerLinkActive="active" (click)="handleNavigation('transactions')">
      
      <a>Activity</a>
    </li>

    <li *ngIf="isLoggedIn" [routerLink]="['/tiers']" routerLinkActive="active" (click)="handleNavigation('tiers')">
      <a>Rewards</a>
    </li>
    <li [routerLink]="['/offers']" routerLinkActive="active" (click)="handleNavigation('offers')">
      <a>Offers</a>
    </li>
  </ul>
</div>
